module.exports = __webpack_public_path__ + "static/bluesafari1-639ea60ebd2789108961defc31b53620.jpeg";